import React from 'react';
import { useTheme } from '@emotion/react';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';
import { DeviceTypes } from '@gumtree/shared/src/types/client-data';
import { useShowPayShipFeature } from '@gumtree/shared/src/hooks/useShowPayShipFeature';
import SideMenuSection from './side-menu-section';
import sideMenuData from './side-menu-data';
import SideNav from '../side-nav/side-nav';
import { sideMenuCss } from './side-menu.style';

interface SideMenuProps {
    baseConfig: {
        sellerUrl: string;
        device: {
            type?: DeviceTypes;
            os?: string;
        };
        pageType: string;
    };
    isLoggedIn?: boolean;
    openDialog?: (event: React.MouseEvent) => void;
}

const SideMenu: React.FC<SideMenuProps> = ({
    baseConfig: { device, pageType, sellerUrl },
    isLoggedIn = false,
    openDialog = () => null,
}) => {
    const theme = useTheme();
    const showPayShipFeature = useShowPayShipFeature();

    return (
        <div className="side-menu-container" css={sideMenuCss(theme)}>
            <SideNav dark right>
                {({ close }: { close: () => void }) => (
                    <nav className="side-menu" {...qaAttribute('side-menu')}>
                        {sideMenuData({ device, sellerUrl }, isLoggedIn, showPayShipFeature).map(
                            (section) => (
                                <SideMenuSection
                                    key={section.id}
                                    isLoggedIn={isLoggedIn}
                                    title={section.title}
                                    openDialog={openDialog}
                                    onItemClick={close}
                                    items={section.items}
                                    pageType={pageType}
                                />
                            )
                        )}
                    </nav>
                )}
            </SideNav>
        </div>
    );
};

export default SideMenu;
